<template>
  <v-card>
    <v-card-title>{{ dataProp.title }} 
      <v-btn text icon v-if="$store.getters['isAdministrator']" @click="$refs.titleDialog.show(dataProp.title)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn></v-card-title>
      <TextDialog ref="titleDialog" title="Title" :onChanged="onTitleChange" />
    <v-card-text>
      <FCCProperty :text="dataProp.competition.title" translation="application.competition" />
      <FCCProperty translation="application.category">
        <template v-slot:header>
          <v-select @change="categoryDialog = true" v-if="$store.getters['isAdministrator']" :items="categories" item-text="name" item-value="id" v-model="dataProp.assignedCategoryID"></v-select>
          <span v-else>{{ dataProp.assignedCategory?dataProp.assignedCategory.name:"" }}</span>
        </template>
      </FCCProperty>
      <FCCProperty translation="ctrl.status">
        <template v-slot:header>
          <FCCApplicationStatus :status="dataProp.status" />
        </template>
      </FCCProperty>
      <FCCProperty :text="applicationType(dataProp.applicationType)" translation="application.type" />
      <FCCProperty :text="dataProp.contactEmail" translation="application.email" />
      <FCCProperty :text="dataProp.code" translation="application.code" v-if="dataProp.code" />
      <FCCProperty translation="ctrl.language" v-if="dataProp.language">
        <template v-slot:header>
          <span><flag :iso="dataProp.language | localeToCountry" /> {{ $t('lang.'+dataProp.language) }}</span>
        </template>
      </FCCProperty>
    </v-card-text>
      <p class="ma-5">
      {{ dataProp.remarks }}
      </p>
    <v-card-actions>
      <v-btn @click="dialog = true" color="error" v-if="$store.getters['isAdministrator'] && !this.dataProp.canceled">{{ $t('ctrl.cancel') }}</v-btn>
      <v-btn @click="deleteDialog = true" color="error" v-if="$store.getters['isAdministrator'] && this.dataProp.canceled">{{ $t('ctrl.delete') }}</v-btn>
      <v-btn @click="remindDialog = true" color="success" v-if="$store.getters['isAdministrator'] && !this.dataProp.canceled">{{ $t('application.remindParticipation') }}</v-btn>
    </v-card-actions>
    <v-dialog v-model="dialog" persistent max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t('application.confirmCancelText') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="dialog = false">{{ $t('ctrl.close') }}</v-btn>
          <v-btn color="success darken-1" @click="confirmYes()">{{ $t('ctrl.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t('application.confirmDeleteText') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="deleteDialog = false">{{ $t('ctrl.close') }}</v-btn>
          <v-btn color="success darken-1" @click="confirmDelete()">{{ $t('ctrl.delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="categoryDialog" persistent max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t('application.confirmCategoryChange') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="categoryDialog = false; reload()">{{ $t('ctrl.close') }}</v-btn>
          <v-btn color="success darken-1" @click="changeCategory()">{{ $t('ctrl.change') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="remindDialog" persistent max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t('application.remindParticipationConfirmation') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="remindDialog = false;">{{ $t('ctrl.close') }}</v-btn>
          <v-btn color="success darken-1" @click="remind()">{{ $t('application.remindParticipation') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :timeout="5000">
      {{ $t('application.remindersSent') }}
      <v-btn
        color="red"
        @click="snackbar = false">
        {{ $t('ctrl.close') }}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDialog,
    VSnackbar
  } from 'vuetify/lib'
  import FCCProperty from '../FCCProperty'
  import fccapi from '../../fccapi.js'
  import FCCApplicationStatus from '../FCCApplicationStatus'
  import TextDialog from '../../dialogs/TextDialog'

  export default {
    name: 'FCCApplicationDetails',
    props: {
      dataProp: Object,
      reload: Function
    },
    data: function(){
      return {
        dialog: false,
        categories: [],
        categoryDialog: false,
        remindDialog: false,
        snackbar: false,
        deleteDialog: false
      };
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        FCCApplicationStatus,
        VDataTable,
        VDialog,
        VSnackbar,
        FCCProperty,
        TextDialog
    },
    methods: {
      applicationType: function(i) {
        return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
      },
      confirmYes: function(){
        this.dialog = false;
        fccapi.post(`applications/${this.dataProp.id}/cancel`, null).then(r => {
          console.log(r);
          this.reload();
        }).catch(e => {
          this.$store.dispatch('reportError', e.response.status);
        });
      },
      changeCategory: function(){
        fccapi.post(`applications/${this.$route.params.id}`, {
          assignedCategoryID: this.dataProp.assignedCategoryID
        }).then(d => {
          this.categoryDialog = false
        })
      },
      remind: function(){
        fccapi.post(`applications/${this.$route.params.id}/remind`).then(d => {
          this.snackbar = true
          this.remindDialog = false
        })
      },
      confirmDelete: function(){
        fccapi.delete(`applications/${this.$route.params.id}`).then(d => {
          this.$router.push('/app/applications');
        }).catch(e => {});
      },
      onTitleChange: function(title){
        if(title != this.dataProp.title && title && title != ""){
          fccapi.post(`applications/${this.$route.params.id}`, {
            title: title
          }).then(d => {
            this.reload();
          })
        }
      }
    },
    mounted: function(){
      fccapi.competitionGet('categories').then(d => {
        this.categories = d.data.filter(a => a.applicationType == this.dataProp.applicationType)
      })
    }
    
  }
</script>
<style>
  .tag{
    width:130px;
    display:inline-block;
  }
</style>